// import { IGridColumnProps } from "../.."; // Unused import
import { IColumn } from '../../types';
import { AgentColumn } from './agent';
import { CourseColumn } from './course';
import { FeeStatusColumn } from './feeStatus';
import { NationalityColumn } from './nationality';
import { StudentColumn } from './offerStudent';
import { SelectColumn } from './select';
import { StatusColumn } from './status';
import { UniversityNameColumn } from './universityName';
import { ApplicantLastUpdatedColumn } from '../offerColumns/applicantLastUpdated';
import { DaysInStage } from '../offerColumns/daysInStage';

/**
 * In some pages, we render application columns, but those pages may show both applications and offers.
 * In these cases, we need to ensure that the columns we return can handle both applications and offers without breaking.
 * This function returns the full set of application columns, which should be safe to use in these mixed contexts.
 */

export const getApplicationColumns = (): IColumn[] => [
  SelectColumn(),
  StudentColumn(),
  UniversityNameColumn(),
  FeeStatusColumn(),
  NationalityColumn(),
  AgentColumn(),
  CourseColumn(),
  StatusColumn(),
  ApplicantLastUpdatedColumn(),
  DaysInStage(),
];
